export class BaseStore {
    executeRecaptcha = (action: (token: string) => void) => {
        grecaptcha.ready(() => {
            grecaptcha.execute("6Le9UDEhAAAAALyTfAqjHqWmU7CbWYHranRY1ly8", {action: 'submit'}).then(async (token) => {
                action(token);
            });
        });
    }
}
